module.exports = __webpack_public_path__ + "img/back-blue.8611f7e6.svg";